import * as __glob_0 from './../audience-cards.js';
import * as __glob_1 from './../benefits-scroll.js';
import * as __glob_2 from './../copy-youtube-html.js';
import * as __glob_3 from './../faq.js';
import * as __glob_4 from './../flip-cards.js';
import * as __glob_5 from './../footer.js';
import * as __glob_6 from './../form.ts';
import * as __glob_7 from './../hero-marquee.js';
import * as __glob_8 from './../navbar.js';
import * as __glob_9 from './../pipedrive-webforms.js';
import * as __glob_10 from './../post-content.js';
import * as __glob_11 from './../process-comparison.js';
import * as __glob_12 from './../process.js';
import * as __glob_13 from './../ressources-preview.js';
import * as __glob_14 from './../service-overview.js';
import * as __glob_15 from './../service-phase-tabs.js';
import * as __glob_16 from './../steps-to-success.js';
import * as __glob_17 from './../testimonial-carousel.js';
import * as __glob_18 from './../tool-benefits-carousel.js';
import * as __glob_19 from './../tool-downsides-carousel.js';
import * as __glob_20 from './../tools-hero.js';
import * as __glob_21 from './../tools-tease.js';
const modules = { "./../audience-cards.js": __glob_0, "./../benefits-scroll.js": __glob_1, "./../copy-youtube-html.js": __glob_2, "./../faq.js": __glob_3, "./../flip-cards.js": __glob_4, "./../footer.js": __glob_5, "./../form.ts": __glob_6, "./../hero-marquee.js": __glob_7, "./../navbar.js": __glob_8, "./../pipedrive-webforms.js": __glob_9, "./../post-content.js": __glob_10, "./../process-comparison.js": __glob_11, "./../process.js": __glob_12, "./../ressources-preview.js": __glob_13, "./../service-overview.js": __glob_14, "./../service-phase-tabs.js": __glob_15, "./../steps-to-success.js": __glob_16, "./../testimonial-carousel.js": __glob_17, "./../tool-benefits-carousel.js": __glob_18, "./../tool-downsides-carousel.js": __glob_19, "./../tools-hero.js": __glob_20, "./../tools-tease.js": __glob_21 };
// console.log("modules -> []", modules);

// Extend HTMLElement interface to include our custom property
declare global {
  interface HTMLElement {
    _moduleInitialized?: boolean;
  }
}

export function createCycles(dataAttribute = "module") {
  return Array.from(document.querySelectorAll(`[data-${dataAttribute}]`))
    .map((element) => {
      const htmlElement = element as HTMLElement;
      const attributeValue = htmlElement.dataset[dataAttribute];

      // Check if THIS SPECIFIC ELEMENT is already initialized
      if (htmlElement._moduleInitialized) {
        return null; // Skip this specific element
      }

      const modulePath = modules[`./../${attributeValue}.ts`]
        ? `./../${attributeValue}.ts`
        : `./../${attributeValue}.js`;

      if (modules[modulePath]) {
        // Expecting a default export function
        const moduleFn = (
          modules[modulePath] as {
            default: (el: HTMLElement, dataset: DOMStringMap) => any;
          }
        ).default;
        if (typeof moduleFn === "function") {
          try {
            // Mark THIS SPECIFIC ELEMENT as initialized
            htmlElement._moduleInitialized = true;

            return moduleFn(htmlElement, htmlElement.dataset);
          } catch (error) {
            // Remove the flag if initialization fails
            delete htmlElement._moduleInitialized;
            console.warn(
              `Failed to call default function for ${dataAttribute} "${attributeValue}":`,
              error
            );
            return null;
          }
        } else {
          console.warn(
            `Default export is not a function for ${dataAttribute} "${attributeValue}"`
          );
          return null;
        }
      } else {
        console.warn(`${dataAttribute} not found: "${attributeValue}"`);
        return null;
      }
    })
    .filter((item) => item !== null);
}

// Optional: Helper function to manually clear initialization for testing
export function clearModuleInitialization(element: HTMLElement) {
  delete element._moduleInitialized;
}
